module.exports = __webpack_public_path__ + "img/index-price.3744637b.jpg";